import { useTLang } from 'intl/intl';

export function useSFStockoutItemChip(props: Props) {
  const { mode } = props;

  const isStockout = mode === 'stockout';

  const lang = {
    label: useTLang({
      id: isStockout ? 'substitutionFlow.003' : 'substitutionFlow.025',
    }),
  };

  return {
    lang,
    isStockout,
  };
}

interface Props {
  mode: 'stockout' | 'replacement';
}
